(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/slicedToArray", "@babel/runtime/helpers/asyncToGenerator", "idb-keyval"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/slicedToArray"), require("@babel/runtime/helpers/asyncToGenerator"), require("idb-keyval"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.slicedToArray, global.asyncToGenerator, global.idbKeyval);
    global.cache = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _slicedToArray2, _asyncToGenerator2, _idbKeyval) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getCachedMessagesToDelete = _exports.determineRemainingStorageQuota = _exports.addNewMessagesToCache = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  /**
   * Detect amount of local storage remaining (quota) and used (usage).
   * If usageDetails exist (not supported in Safari), use this instead of usage.
   */
  var determineRemainingStorageQuota = _exports.determineRemainingStorageQuota = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _ref2, _storage$usageDetails, _storage$usageDetails2, storage, mobileBrowserQuota, estimatedBrowserQuota, messageQuota, usage, remainingQuota, _err$response$data$cl, _err$response, _err$response$data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if ('indexedDB' in window) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", 0);
          case 3:
            if (!('storage' in navigator && 'estimate' in navigator.storage)) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return navigator.storage.estimate();
          case 6:
            _context.t0 = _context.sent;
            _context.next = 10;
            break;
          case 9:
            _context.t0 = undefined;
          case 10:
            storage = _context.t0;
            /** 50 MB is the lower common denominator on modern mobile browser caches. */
            mobileBrowserQuota = 52428800;
            /** Max quota of browser storage that in-apps will potentially fill */
            estimatedBrowserQuota = storage === null || storage === void 0 ? void 0 : storage.quota;
            /**
             * Determine lower max quota that can be used for message cache, set to
             * 60% of quota to leave space for other caching needs on that domain.
             */
            messageQuota = ((_ref2 = estimatedBrowserQuota && Math.min(estimatedBrowserQuota, mobileBrowserQuota)) !== null && _ref2 !== void 0 ? _ref2 : mobileBrowserQuota) * 0.6;
            /** How much local storage is being used. */
            usage = (_storage$usageDetails = storage === null || storage === void 0 ? void 0 : (_storage$usageDetails2 = storage.usageDetails) === null || _storage$usageDetails2 === void 0 ? void 0 : _storage$usageDetails2.indexedDB) !== null && _storage$usageDetails !== void 0 ? _storage$usageDetails : storage === null || storage === void 0 ? void 0 : storage.usage;
            remainingQuota = usage && messageQuota - usage;
            return _context.abrupt("return", remainingQuota || 0);
          case 19:
            _context.prev = 19;
            _context.t1 = _context["catch"](0);
            // eslint-disable-next-line no-console
            console.warn('Error determining remaining storage quota', (_err$response$data$cl = _context.t1 === null || _context.t1 === void 0 ? void 0 : (_err$response = _context.t1.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.clientErrors) !== null && _err$response$data$cl !== void 0 ? _err$response$data$cl : _context.t1);
          case 22:
            return _context.abrupt("return", 0);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 19]]);
    }));
    return function determineRemainingStorageQuota() {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Deletes cached messages not present in latest getMessages fetch.
   * @param cachedMessages
   * @param fetchedMessages
   */
  var getCachedMessagesToDelete = _exports.getCachedMessagesToDelete = function getCachedMessagesToDelete(cachedMessages, fetchedMessages) {
    return cachedMessages.reduce(function (deleteQueue, _ref3) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 1),
        cachedMessageId = _ref4[0];
      var isCachedMessageInFetch = fetchedMessages.reduce(function (isFound, _ref5) {
        var messageId = _ref5.messageId;
        // eslint-disable-next-line no-param-reassign
        if (messageId === cachedMessageId) isFound = true;
        return isFound;
      }, false);
      if (!isCachedMessageInFetch) deleteQueue.push(cachedMessageId);
      return deleteQueue;
    }, []);
  };

  /**
   * Adds messages to cache only if they fit within the quota, starting with
   * oldest messages since newer messages can still be easily retrieved via
   * new requests while passing in latestCachedMessageId param.
   * @param messages
   * @param quota
   */
  var addNewMessagesToCache = _exports.addNewMessagesToCache = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(messages) {
      var quota, messagesWithSizes, remainingQuota, messagesToAddToCache, _err$response$data$cl2, _err$response2, _err$response2$data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return determineRemainingStorageQuota();
          case 2:
            quota = _context2.sent;
            if (!(quota > 0)) {
              _context2.next = 16;
              break;
            }
            /**
             * Determine total size (in bytes) of new messages to be added to cache
             * sorted oldest to newest (ascending createdAt property).
             */
            messagesWithSizes = messages.map(function (_ref7) {
              var messageId = _ref7.messageId,
                message = _ref7.message;
              var sizeInBytes = new Blob([JSON.stringify(message).replace(/\[\[\],"\]/g, '')]).size;
              return {
                messageId: messageId,
                message: message,
                createdAt: message.createdAt,
                size: sizeInBytes
              };
            }).sort(function (a, b) {
              return a.createdAt - b.createdAt;
            });
            /** Only add messages that fit in cache, starting from oldest messages. */
            remainingQuota = quota;
            messagesToAddToCache = [];
            messagesWithSizes.every(function (_ref8) {
              var messageId = _ref8.messageId,
                message = _ref8.message,
                size = _ref8.size;
              if (remainingQuota - size < 0) return false;
              remainingQuota -= size;
              messagesToAddToCache.push([messageId, message]);
              return true;
            });
            _context2.prev = 8;
            _context2.next = 11;
            return (0, _idbKeyval.setMany)(messagesToAddToCache);
          case 11:
            _context2.next = 16;
            break;
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](8);
            // eslint-disable-next-line no-console
            console.warn('Error adding new messages to the browser cache', (_err$response$data$cl2 = _context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.clientErrors) !== null && _err$response$data$cl2 !== void 0 ? _err$response$data$cl2 : _context2.t0);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[8, 13]]);
    }));
    return function addNewMessagesToCache(_x) {
      return _ref6.apply(this, arguments);
    };
  }();
});